import React, { Fragment, useRef } from 'react'
import { Dialog, Transition } from '@headlessui/react'
import { NavLink } from 'react-router-dom'
import { GrClose } from "react-icons/gr"
import CircularProgressbar from '../Dashboard/AssetAllocation/CircularProgressbar'
import WebService from '../../../utility/WebService'
import { useEffect, useState } from "react";
import HelperService from '../../../utility/HelperService'
import Loader from '../../../components/Loader/Loader'
import { CgClose } from 'react-icons/cg';
import { BsPlusCircle, BsQuestionCircle, BsPieChart, BsCircleFill } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import WarningModal from "../../../components/Warning/Warning";
import SucessModal from "../../../components/SucessModal/Sucess";
import { useForm } from "react-hook-form";
import { Label } from '../../../components/Label/Label'
import CircularProgressbarDisplay from '../../Admin/FinancialPlanning/AssetMapping/CircularProgressbarDisplay';
import ArcheivedGoalsPopUp from '../../DataEntryOperator/Goals/ArcheivedGoalsPopUp';
// import ArcheivedGoals from '../../DataEntryOperator/Goals/ArcheivedGoals';
import {
    GridContextProvider,
    GridDropZone,
    GridItem,
    swap,
    move
} from "react-grid-dnd";

const Goals = () => {
    const {
        register,
        handleSubmit,
        reset,
        control,
        setValue,
        formState: { errors },
    } = useForm();
    const [open, setOpen] = useState(false);
    const [open2, setOpen2] = useState(false);
    const [open3, setOpen3] = useState(false);
    const cancelButtonRef = useRef(null);
    const cancelButtonRef3 = useRef(null);
    const [showLoader, setShowLoader] = useState(false);
    const [goals, setGoals] = useState<any[]>([]);
    const [changedPriorityGoals, setChangedPriorityGoals] = useState<any[]>([]);
    const [pIChartPopup, setPIChartPopup] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [goalName, setGoalName] = useState('');
    const [goalNature, setGoalNature] = useState('');
    const [assetEarmarkedList, setAssetEarmarkedList] = useState<any[]>([]);

    const [riskProfile, setRiskProfile] = useState<any>();
    const [assetsInRule, setAssetInRule] = useState<any[]>([]);
    const [isShoWDeleteModal, setShowDeleteModal] = useState(false);
    const [deletedData, setDeletedData] = useState<any>({});
    const [doughnutLabelData, setLabeldonutData] = useState<any[]>([]);
    const [sucessMessage, setSucessMessage] = useState<any>()
    const [isShowSucessModal, setShowSucessModal] = useState(false);
    const [warningMessage, setWarningMessage] = useState<any>()
    const [isShowWarningModal, setShowWarningModal] = useState(false);
    const [isMapped , setIsMapped] = useState(false);

    const [assetsInMannual, setAssetInMannual] = useState<any[]>([]);
    const [addAssetsPopup, setAddAssetsPopup] = useState(false)
    const [addAssetMannualPopup, setAddAssetMannualPopup] = useState(false)
    const [doughnutData, setDoughnutData] = useState<any[]>([]);
    const [doughnutData2, setDoughnutData2] = useState<any[]>([]);
    const [doughnutBackgroundColorData, SetDoughnutBackgroundColorData] = useState<any[]>([]);
    const [doughnutBackgroundColorData2, SetDoughnutBackgroundColorData2] = useState<any[]>([]);
    const [doughnutLabelData2, setLabeldonutData2] = useState<any[]>([]);
    const [priorityData, setPriorityData] = useState<any[]>([]);
    const [goalMaturityDate, setGoalMaturityDate] = useState('');
    const [selfTenure, setSelfTenure] = useState('');
    const [goalsLiabilitiesDetailsId, setGoalsLiabilitiesDetailsId] = useState(0);
    const [assetListDefinedInRule, setAssetListDefinedInRule] = useState<any[]>([]);
    const [assetListDefinedInMannual, setAssetListDefinedInMannual] = useState<any[]>([]);
    const [goalMaturityRequiredAmount, setGoalMaturityRequiredAmount] = useState(0);
    const [CustomerFinancialPlanningId, setCustomerFinancialPlanningId] = useState(0);
    const [showGif, setShowGif] = useState<boolean>(false);
    const [isChecked, setIsChecked] = useState<boolean>(false);
    const [isDeo, setIsDeo] = useState(false);
    const [isGoalAlertShow , setIsGoalAlertShow] = useState(false);
    const [height, setHeight] = useState(0);
    const token_pre = localStorage.getItem("token_pre");

    let cfpId = localStorage.getItem('cfpid');
    let history = useNavigate();

    useEffect(() => {
        getCustomerFinancialPlanningId();
        getDetail();
        //changePriority();
        getUserData();
        //const dndGifShow = localStorage.getItem('goals_dnd_gif');
       // console.log('localstorage item....',dndGifShow)
        // if(!dndGifShow){
        //     setShowGif(true);
        // }
    }, []);

    const getUserData = () => {
        //setLoading(true);
        WebService.postAPI({
          action: `/login/LoginUserDetails`,
          body: {token_pre:token_pre},
        })
          .then((res: any) => {
           var user_data = res.result;
           
        if (user_data && user_data.roles && user_data.roles.length > 0) {
          for (var i in user_data.roles) {
            //alert(user_data.roles[i].id)
            if (user_data.roles[i].id === "Data Entry Operator") {
              setIsDeo(true)
            }
            
          }
        }
            //setLoading(false);
            //localStorage.setItem("user_Detail", JSON.stringify(res.result));
          })
          .catch((e) => {
            //setLoading(false);
          });
      };


    useEffect(() => {
        // console.log('goals details are....', changedPriorityGoals);
        changePriority();
    }, [changedPriorityGoals])
    const getCustomerFinancialPlanningId = () => {

        WebService.getAPI({
            action: `/v2/CustomerFinancialPlanning/GetCustomerFinancialPlanningID`,
            //body: null,
        }).then((res: any) => {
            setCustomerFinancialPlanningId(res.id)
        }).catch((e) => {

        });
    }
    const getDetail = () => {
        setShowLoader(true);
        WebService.postAPI({
            action: `/v2/GoalsLiabilitiesDetails/GoalsLiabilitiesDetailsList?is_active=${1}`,
        })
            .then((res: any) => {
                const resetPriority = res.list.map((itm:any, idx:any) => {
                   return {...itm, priority: idx+1};
                })
                setChangedPriorityGoals(resetPriority);
                let height = Math.ceil(res.count / 3) * 240;
                setHeight(height);
                // console.log('resetPriority....',resetPriority)
                setGoals(resetPriority);
                if(res.is_goal_alert_show == 1){
                setIsGoalAlertShow(true)
                }
                setShowLoader(false);
                
            })
            .catch(() => {
                setShowLoader(false);
            });
    };
    const changePriority = () => {
        setShowLoader(true);
        WebService.postAPI({
            action: `/v2/GoalsLiabilitiesDetails/SetPriority`,
            body: JSON.stringify(changedPriorityGoals),
        })
            .then((res: any) => {
                // getDetail();
                setShowLoader(false);
            })
            .catch(() => {
                setShowLoader(false);
            });
    };

    //Below function used on click of show PI chard of goal widzard
    const getMappedAssetsForGoal = (goals_liabilities_details_id: any) => {
        //setLoading(true)
        setGoalsLiabilitiesDetailsId(goals_liabilities_details_id);

        WebService.getAPI({
            action: `/v2/AssetMappingActivity/GetMappedAssets?customer_financial_planning_id=${CustomerFinancialPlanningId}&goals_liabilities_details_id=${goals_liabilities_details_id}`,
            body: null,
        }).then((res: any) => {
            setGoalName(res.goal_name);
            setGoalNature(res.goal_nature);
            setGoalMaturityDate(res.maturity_date);
            setSelfTenure(res.self_tenure);
            
            if(res.goal_liability_name != 33){
                setGoalMaturityRequiredAmount(res.goal_maturity_required);
            }else{
                setGoalMaturityRequiredAmount(0);
            }
            getRiskProfileDetails();
            setAssetEarmarkedList(res.list); //ITs actually mapped asset to goal list

            setPIChartPopup(true);
            setLoading(false)

        }).catch((e) => {

        });
    }
    const PIChartDetails = (goals_liabilities_details_id: number) => {
        setLoading(true)
        setGoalsLiabilitiesDetailsId(goals_liabilities_details_id)

        WebService.getAPI({
            action: `/v2/AssetMappingActivity/PIChartDetails?customer_financial_planning_id=${CustomerFinancialPlanningId}&goals_liabilities_details_id=${goals_liabilities_details_id}`,
            body: null,
        }).then((res: any) => {
            setDoughnutData(res.doughNut.data);
            setLabeldonutData(res.doughNut.label);
            SetDoughnutBackgroundColorData(res.doughNut.backgroundColor);

            setDoughnutData2(res.doughNut2.data);
            setLabeldonutData2(res.doughNut2.label);
            SetDoughnutBackgroundColorData2(res.doughNut2.backgroundColor);

            getMappedAssetsForGoal(goals_liabilities_details_id); //loading false in this function

        }).catch((e) => {

        });
    };
    const getRiskProfileDetails = () => {
        WebService.getAPI({
            action: `/v2/NewRiskProfileAnswerDetails/getRiskProfileRating?customer_financial_planning_id=${CustomerFinancialPlanningId}`,
            body: null,
        }).then((res: any) => {
            setRiskProfile(res.list);
        }).catch((e) => {

        });
    };


    const onDeleteGoal = (data: any) => {
        setShowLoader(true);
        var obj = {
            id: data.id,
            value: data.name
        };
        setDeletedData(obj);
        WebService.postAPI({
            action: `/v2/GoalsLiabilitiesDetails/DeleteReason?id=${data.id}`,
            body: data,
        })
            .then((res: any) => {
                setShowLoader(false);
               // console.log(res.message)
                if (res.message === 'No Mapped') {
                    setValue("reason", '');
                    setOpen2(true);
                    setIsMapped(false);
                }
                else {
                    setShowLoader(false);
                    setValue("reason", '');
                    setOpen2(true);
                    setIsMapped(true);
                }
            })
            .catch((e) => {
                setShowLoader(false);
            });
    };

    const DeleteReason = (data?: any) => {
        setOpen2(false)
        setShowLoader(true);
        setShowDeleteModal(false);
        WebService.postAPI({
            action: `/v2/GoalsLiabilitiesDetails/Delete?id=${deletedData.id}`,
            body: data,
        })
            .then((res: any) => {
                setShowSucessModal(true);
                setSucessMessage(res.message)
                getDetail();
                setShowLoader(false);
            })
            .catch((e) => {
                setShowLoader(false);
                setShowWarningModal(true);
                setWarningMessage(e.message)
            });
    };

    const warningCloseModal = () => {
        setShowWarningModal(false)
        setShowLoader(false);
    }

    const sucessCloseModal = () => {
        setShowSucessModal(false)
        setShowLoader(false);
    }

    // useEffect(()=>{
    //    console.log('goals,.',goals);
    // },[goals])

    const handgleDragEnd = (sourceId: any, sourceIndex: number, targetIndex: number, targetId: any) => {
        console.log('handle drag end.....', sourceId, "...", sourceIndex, "....", targetIndex, '.....', targetId);
        const result = handleMove(goals, sourceIndex, targetIndex);
        setGoals(result)
        const changedPriorityResult = result.map((item: any, idx: number) => {
            return { ...item, priority: idx + 1 };
        })
        return setChangedPriorityGoals(changedPriorityResult);
    };

    const handleMove = (array: any, fromIndex: number, toIndex: number) => {
        const arrayCopy = Array.from(array);
        const [movedItem] = arrayCopy.splice(fromIndex, 1);
        arrayCopy.splice(toIndex, 0, movedItem);
        return arrayCopy;
    };

    const handleOkayGotIt = () =>{
        setIsGoalAlertShow(false)
        //setShowGif(false);
    }

    const handleCheckBox =() =>{
        const newCheck = !isChecked;
        if(newCheck){
            //localStorage.setItem('goals_dnd_gif','true');
            updateShowAlertStatus(true);
        }
        else{
            //localStorage.setItem('goals_dnd_gif','false');
            updateShowAlertStatus(false);
        }
        setIsChecked(newCheck);
    }


    const updateShowAlertStatus = (status :boolean) => {
        WebService.getAPI({
            action: `/v2/GoalsLiabilitiesDetails/UpdateGoalAlertStatus?status=${status}`,
            body: null,
        }).then((res: any) => {
            // setRiskProfile(res.list);
        }).catch((e) => {

        });
    };

    const handleHelp= () =>{
        setIsGoalAlertShow(true)
        //setShowGif(true);
    }

    return (
        <>
            <SucessModal
                show={isShowSucessModal}
                isClose={sucessCloseModal}
                message={sucessMessage}
            />
            <WarningModal
                show={isShowWarningModal}
                isClose={warningCloseModal}
                message={warningMessage}
            />
            {/* <Loader show={isLoading} /> */}
            <Loader show={showLoader} />
            {( isGoalAlertShow && !isDeo) && (
                <div className='fixed z-[1000] flex justify-center items-center w-[100%]'>
                    <div className=' items-center  bg-[#FFF] rounded-lg flex flex-col gap-[10px] p-[24px] md:w-[924px]'>
                        <div className=' text-[#111827] text-lg font-semibold font-sans'>
                            <span>You can drag and drop goals to adjust their priority!</span>
                        </div>
                        <div>
                            <img src='/images/dnd_goals.gif' alt='gif.....' />
                        </div>
                        <div onClick={handleCheckBox} className='cursor-pointer flex gap-[8px] text-[#000] text-sm font-normal font-sans items-center'>
                            <input
                                type="checkbox"
                            checked={isChecked}
                            // onChange={handleCheckBox}
                            ></input>
                            <span>Do not show this again</span>
                        </div>
                        <div onClick={handleOkayGotIt}>
                            <button className=' bg-[#7B5AEC] rounded px-[24px] py-[8px] text-[#FFF] text-sm font-semibold font-sans'>Okay, got it!</button>
                        </div>
                    </div>
                </div>
            )}
            <div className="page-content-wraper text-sm">
                <div className="grid grid-cols-2 gap-4 mb-3">
                    <div><h1 className="page-title"> Goals</h1></div>
                    <div className="text-right">
                        <button onClick={handleHelp}>
                            <span className='mr-3 text-[#11182780] text-sm font-medium font-sans'>Drag and drop to re-adjust the priority</span>
                        </button>
                        <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3" title="Help">
                            <BsQuestionCircle size={20} className="inline mr-1" /> Help
                        </button>
                        <button type="button" className="btn bg-white px-3 py-1 rounded-md hover:shadow-xl  shadow-sm mr-3" title="Archive" onClick={() => history(`/goals/archeived-goal`)}>
                            <svg className="icon inline mr-2" width={20} height={20} >
                                <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#archivedIcon"></use>
                            </svg> Archived
                        </button>
                        <NavLink to="/goals/add-goal" className="btn btn-brand btn-sm" >+ Add</NavLink>
                    </div>
                </div>
                {goals.length > 0 ?
                    <GridContextProvider onChange={handgleDragEnd}>
                        <div className=' flex mx-[1rem] my-[auto] w-[100%] h-[100%]'>
                            <GridDropZone
                                id="priority"
                                boxesPerRow={3}
                                rowHeight={240}
                                style={{
                                    flex: '1',
                                    // height: '800px'
                                    height: height
                                }}
                            >
                                {goals && goals.map((res, index) => {
                                    //alert(res.mapped_percentage)
                                    var mapped_percentage = res.mapped_percentage <= 0 ? 8 : res.mapped_percentage;
                                    if(res.mapped_percentage>0 && res.goal_liability_name==33){
                                        res.mapped_percentage = 100;
                                    } //For Wealth Building Goal
                                    return (
                                        <GridItem key={res.priority}>
                                            <div className="rounded-xl m-[16px] cursor-grab shadow bg-white">
                                                <div title={res.display_goal ? res.display_goal : ''} className="bg-[#F9F8FF] p-4 flex items-center rounded-t-xl justify-between">
                                                    <span style={{ marginLeft: '0px' }} className=" bg-brand inline-flex text-white text-xs justify-center items-center w-6 h-6 rounded-full ml-1 absolute  position-relative">{index + 1}</span>
                                                    <h3 className="text-[18] font-semibold overflowtext"

                                                        style={{ maxWidth: '180px', marginLeft: '27px' }}>{res.display_goal ? res.display_goal : "-"}
                                                    </h3>
                                                    <div className="text-right">
                                                        <a className="mb-2 cursor-pointer" onClick={() => PIChartDetails(res.goals_liabilities_details_id)}>
                                                            <svg className="icon inline mr-2" width={24} height={24}  >
                                                                <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#pieChartIcon"></use>
                                                            </svg>
                                                        </a>
                                                        <a onClick={() => history(`/goals/edit-goal/${res.goals_liabilities_details_id}`)} className=" hover:opacity-60 mb-2 cursor-pointer" title='Edit'>
                                                            <svg className="icon inline mr-2" width={18} height={18} >
                                                                <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#edit"></use>
                                                            </svg>
                                                        </a>
                                                        { //res.type !='Implicit Liability' &&
                                                            <a
                                                                onClick={() => {
                                                                    onDeleteGoal({ id: res.goals_liabilities_details_id, name: res.display_goal });
                                                                }}
                                                                href="javascript:void(0)" className="action-btn" title="Delete">
                                                                <svg className="icon inline " width={20} height={20} >
                                                                    <use xlinkHref="/images/svg-sprint/common-icon-sprint.svg#delete"></use>
                                                                </svg>
                                                            </a>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="p-4 ">
                                                    <div className="flex justify-between mb-1">
                                                        <div className=" ">Maturity date :</div>
                                                        <div className="t font-semibold">{res.maturity_date ? HelperService.getFormatedDateByDMY(res.maturity_date) : "NA"}</div>
                                                    </div>
                                                    <div className="flex justify-between mb-1">
                                                        <div className=""> Amount required :</div>
                                                        <div className=" font-semibold">{res.proposed_amount ? '₹' + HelperService.getCurrencyFormatterWithoutDecimal(res.proposed_amount) : "NA"}</div>
                                                    </div>
                                                    <div className="flex justify-between mb-4">
                                                        <div className="">Maturity amount required:</div>
                                                        <div className=" font-semibold">{res.maturity_amount_required ? ('₹' + HelperService.getCurrencyFormatterWithoutDecimal(res.maturity_amount_required)) : "NA"}</div>
                                                    </div>
                                                    <div className="progres rounded-lg my-4" title={HelperService.getCurrencyFormatterWithoutDecimal(res.mapped_percentage)}>
                                                        <div className={`progres-bar ${((res.mapped_percentage >= 100) ? 'background-green' : (res.mapped_percentage <= 0)?'background-voilet':'background-orange')}  w-[${parseInt(res.mapped_percentage)}%]`} style={{ padding: '5px', width: mapped_percentage + '%' }} role="progressbar" >{HelperService.getCurrencyFormatterWithoutDecimal(res.mapped_percentage)}%</div>
                                                    </div>
                                                    <div className="flex justify-between  ">
                                                        <div className="">Earmarked: <span className='font-semibold'>₹{HelperService.getCurrencyFormatterWithoutDecimal(res.earmarked)}</span></div>
                                                        <div className="">Difference: <span className='font-semibold'>₹{HelperService.getCurrencyFormatterWithoutDecimal(res.difference)}</span></div>
                                                    </div>
                                                </div>

                                            </div>
                                        </GridItem>
                                    )
                                })}
                            </GridDropZone>
                        </div>
                    </GridContextProvider>
                    : <div className="Nodata" >
                        <h2>No Goals Found</h2>
                    </div>}
            </div >


            <ArcheivedGoalsPopUp open2={open2} cancelButtonRef={cancelButtonRef} setOpen2={setOpen2} handleSubmit={handleSubmit} DeleteReason={DeleteReason} deletedData={deletedData} setDeletedData={setDeletedData} register={register} errors={errors} isMapped={isMapped} ></ArcheivedGoalsPopUp>
            {/* PI Chart Graph modal  */}
            <CircularProgressbarDisplay goal_maturity_required={goalMaturityRequiredAmount} setPIChartPopup={setPIChartPopup} doughnutData2={doughnutData2} doughnutLabelData2={doughnutLabelData2} doughnutBackgroundColorData2={doughnutBackgroundColorData2} doughnutData={doughnutData} doughnutLabelData={doughnutLabelData} doughnutBackgroundColorData={doughnutBackgroundColorData} assetEarmarkedList={assetEarmarkedList} riskProfile={riskProfile} goalNature={goalNature} pIChartPopup={pIChartPopup} addAssetsPopup={addAssetsPopup} goalMaturityDate={goalMaturityDate} cancelButtonRef={cancelButtonRef} setAddAssetsPopup={setAddAssetsPopup} goalName={goalName} assetsInRule={assetsInRule} selfTenure={selfTenure} ></CircularProgressbarDisplay>
        </>
    )
}
export default Goals;
